import { render, staticRenderFns } from "./DirectionCard.vue?vue&type=template&id=0a7ecc5e&scoped=true"
import script from "./DirectionCard.vue?vue&type=script&lang=js"
export * from "./DirectionCard.vue?vue&type=script&lang=js"
import style0 from "./DirectionCard.vue?vue&type=style&index=0&id=0a7ecc5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7ecc5e",
  null
  
)

export default component.exports